import { Header } from "./components/Header";
import { HeroBanner } from "./components/HeroBanner";
import React, { Suspense } from "react";
const AboutSection = React.lazy(() =>
  import("./components/AboutSection").then((m) => ({ default: m.AboutSection }))
);
const FeaturesSection = React.lazy(() =>
  import("./components/FeaturesSection").then((m) => ({
    default: m.FeaturesSection,
  }))
);
const InnovationSection = React.lazy(() =>
  import("./components/InnovationSection").then((m) => ({
    default: m.InnovationSection,
  }))
);
const PromiseSection = React.lazy(() =>
  import("./components/PromiseSection").then((m) => ({
    default: m.PromiseSection,
  }))
);
import { Footer } from "./components/Footer";
import { AnimatedLogo } from "./components/AnimatedLogo";
import { ThemeProvider } from "./components/ThemeProvider";
import { useEffect, useState } from "react";
import { ScrollToTopButton } from "./components/ScrollToTopButton";

export default function App() {
  const [theme, setTheme] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("theme");
      if (stored) return stored;
      if (window.matchMedia("(prefers-color-scheme: dark)").matches)
        return "dark";
      return "light";
    }
    return "light";
  });

  // Listen for system theme changes
  useEffect(() => {
    const mql = window.matchMedia("(prefers-color-scheme: dark)");
    const handleChange = (e) => {
      if (!localStorage.getItem("theme")) {
        setTheme(e.matches ? "dark" : "light");
      }
    };
    mql.addEventListener("change", handleChange);
    return () => mql.removeEventListener("change", handleChange);
  }, []);

  // Apply theme to document
  useEffect(() => {
    document.documentElement.classList.remove("dark", "light");
    document.documentElement.classList.add(theme);
  }, [theme]);

  // Provide a setter for ThemeSwitcher to use
  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  };

  return (
    <ThemeProvider value={{ theme, setTheme: handleThemeChange }}>
      <div className="min-h-screen bg-background font-sans page-transition">
        {/* Animated background particles */}
        <div className="background-particles"></div>

        <Header />
        <AnimatedLogo />
        <HeroBanner />
        <Suspense
          fallback={
            <div className="w-full text-center py-12 text-lg text-muted-light">
              Loading...
            </div>
          }
        >
          <AboutSection />
          <FeaturesSection />
          <InnovationSection />
          <PromiseSection />
        </Suspense>
        <Footer />
        <ScrollToTopButton />
      </div>
    </ThemeProvider>
  );
}
